
export class ProductImage {
    Key: string;
    LastModified: Date;
    ETag: string;
    Size: string;
    StorageClass: string;
    Owner: {
        DisplayName: string;
        ID: string;
    };
    DisplayIndex: number;
    ImageId: string
}

function ProductImage_tsickle_Closure_declarations() {
/** @type {?} */
ProductImage.prototype.Key;
/** @type {?} */
ProductImage.prototype.LastModified;
/** @type {?} */
ProductImage.prototype.ETag;
/** @type {?} */
ProductImage.prototype.Size;
/** @type {?} */
ProductImage.prototype.StorageClass;
/** @type {?} */
ProductImage.prototype.Owner;
/** @type {?} */
ProductImage.prototype.DisplayIndex;
/** @type {?} */
ProductImage.prototype.ImageId;
}
